/**
 * Created by anatoly on 24.06.2025
 */

const Merge2GeneratorTutorial = function () {
    return new TutorialScenario("merge2_generator_tutorial", {
        onStart: function () {
            Merge2GeneratorTutorial.GENERATOR = Merge2GeneratorTutorial.FindTutorialGenerator();
        },

        onFinish: function () {
            Merge2GeneratorTutorial.GENERATOR = undefined;
        },

        isAvailable: function () {
            const location = cleverapps.meta.getSelectedLocation();

            return Merge2.current && !Merge2.current.counter.isActive()
                && location.stars.getAmount() >= location.calcStarsForStage()
                && Merge2.current.field.findEmptySlot(0, 0)
                && Merge2GeneratorTutorial.FindTutorialGenerator();
        },

        listSteps: () => {
            if (!Merge2GeneratorTutorial.GENERATOR) {
                return [];
            }

            let steps = [
                (function () {
                    if (Merge2.current.mode === Merge2.MODE_GAME) {
                        return Merge2TutorialHelper.createWaitRowStep("new_task");
                    }
                }()),
                Merge2TutorialHelper.createOpenTaskWindowStep({}),
                Merge2TutorialHelper.createRepairStep(),

                !Unit.isSideQuest(Merge2GeneratorTutorial.GENERATOR.newLine)
                && !Merge2.current.customers.listCustomersWithRecipe().some((customer) => customer.recipe.getIngredients().some((ingredient) => ingredient.unit.code === Merge2GeneratorTutorial.GENERATOR.newLine))
                && Merge2GeneratorTutorial.createReplaceOrPlaneOrderStep({
                    ingredients: [{ unit: { code: Merge2GeneratorTutorial.GENERATOR.newLine, stage: 3 }, amount: 1 }]
                }),

                Merge2TutorialHelper.createCompleteRepairAnimationStep(),
                new TutorialStep({
                    onStart: function () {
                        const gameLevel = cleverapps.gameLevel;
                        if (!gameLevel || gameLevel.exp.getExp() < gameLevel.nextLevelThreshold()) {
                            this.finish();
                            return;
                        }

                        Merge2.current.showLevelUpWindow(this.finish.bind(this));
                    },

                    onFinish: function () {
                        Merge2.current.counter.trigger();
                    }
                }),
                new TutorialStep({
                    onStart: function () {
                        Merge2.current.bubblesStack.moveTop(Merge2GeneratorTutorial.GENERATOR.unit);
                        this.finish();
                    },

                    onFinish: function () {
                        Merge2.current.counter.trigger();
                    }
                }),
                Merge2TutorialHelper.createSwitchStep({
                    mode: Merge2.MODE_GAME,
                    text: Merge2GeneratorTutorial.getStageText("Merge2.GeneratorTutorial2")
                }),
                Merge2TutorialHelper.createBubbleStackStep({
                    text: Merge2GeneratorTutorial.getStageText("Merge2.GeneratorTutorial3"),
                    unit: Merge2GeneratorTutorial.GENERATOR.unit
                })
            ].filter(Boolean);

            const generator = {
                code: Merge2GeneratorTutorial.GENERATOR.unit.code,
                stage: Merge2GeneratorTutorial.GENERATOR.unit.stage
            };

            if (Merge2.current.field.listAvailableUnits(Merge2GeneratorTutorial.GENERATOR.unit).length > 0) {
                generator.stage++;
                steps = steps.concat(Merge2TutorialHelper.createMergeStep({
                    unit: Merge2GeneratorTutorial.GENERATOR.unit,
                    text: Merge2GeneratorTutorial.getStageText("Merge2.GeneratorTutorial4"),
                    highlightedCells: true
                }));
            }

            if (Families[generator.code].units[generator.stage].generator && !Families[generator.code].sideQuest && cleverapps.lives.canTake(Merge2.current.generatorMultiplier.getValue())) {
                steps = steps.concat(Merge2TutorialHelper.createClickUnitStep({
                    text: Merge2GeneratorTutorial.getStageText("Merge2.GeneratorTutorial5"),
                    unit: generator,
                    forceDrop: Merge2GeneratorTutorial.GENERATOR.newLine,
                    finishEvent: "onUnitSpawned",
                    finishFilter: () => true,
                    highlightedCells: true
                }));
            }

            return steps;
        }

    });
};

Merge2GeneratorTutorial.createReplaceOrPlaneOrderStep = function (recipe) {
    return new TutorialStep({
        onStart: function () {
            const customers = Merge2.current.customers;

            const availableCustomer = customers.customers.find((customer) => customers.isNewOrderAvailable(customer));
            if (availableCustomer) {
                customers.resetCustomerCooldown(availableCustomer);
                customers.resetPlanedOrders();
                customers.planOrder(recipe, "tutorial");
            } else {
                const customerIndex = Merge2.current.customers.listCustomersWithRecipe()
                    .filter((customer) => !customer.recipe.sideQuest)
                    .sort((a, b) => Merge2.current.stock.getLackingUnits(b.recipe.ingredients).length
                        - Merge2.current.stock.getLackingUnits(a.recipe.ingredients).length)[0].customerIndex;

                const customer = customers.list().find((customer) => customer.customerIndex === customerIndex);
                customers.createCustomOrder(customer, recipe);
            }

            this.finish();
        },

        onFinish: function () {
            Merge2.current.counter.trigger();
        }
    });
};

Merge2GeneratorTutorial.getStageText = function (text) {
    const customText = `${text}_line_${Merge2GeneratorTutorial.GENERATOR.newLine}`;
    if (Messages._findInDictionaries(customText)) {
        return customText;
    }
    return text;
};

Merge2GeneratorTutorial.FindTutorialGenerator = function () {
    const location = cleverapps.meta.getSelectedLocation();
    const rewards = location.getRewardsForFix();
    let reward = rewards && rewards.find((reward) => reward.unit && Families[reward.unit.code].type === "generator");

    if (!reward) {
        const expReward = rewards && rewards.find((reward) => reward.exp);
        const expGain = expReward ? expReward.exp : 0;
        if (cleverapps.gameLevel && cleverapps.gameLevel.exp.getExp() + expGain >= cleverapps.gameLevel.nextLevelThreshold()) {
            const levelRewards = cleverapps.gameLevel.getReward();
            reward = levelRewards && levelRewards.find((reward) => reward.unit && Families[reward.unit.code].type === "generator");
        }
    }

    if (!reward) {
        return;
    }
    const generator = reward.unit;

    const availableStage = Merge2.current.getAvailableGeneratorStage(generator.code, true);
    if (availableStage === undefined) {
        return;
    }

    const generatorConfig = OrdersAlgoConfig.generators[generator.code];

    let availableDrop = generatorConfig.stages[availableStage].drop;
    if (!availableDrop) {
        return;
    }

    const existingStage = Merge2.current.getAvailableGeneratorStage(generator.code);
    let existingDrop = existingStage !== undefined && generatorConfig.stages[existingStage].drop;

    if (generatorConfig.algorithm && generatorConfig.algorithm.overrideDrop) {
        availableDrop = generatorConfig.algorithm.overrideDrop;
        if (existingDrop) {
            existingDrop = generatorConfig.algorithm.overrideDrop;
        }
    }

    const newLine = cleverapps.substract(availableDrop, existingDrop || [])[0];

    if (newLine) {
        return {
            newLine,
            unit: generator
        };
    }
};

Merge2GeneratorTutorial.GENERATOR = undefined;